<template>
  <div class="container">
    <router-link to="/">◀︎TOPへ戻る</router-link>
    <div class="title">
      <img src="../assets/mugimusha_title.png">
      <h2>藤原プロジェクト2020</h2>
    </div>
    <h3>概要・コンセプト</h3>
    <div class="content">
      <p>
        3年次通年授業「プロジェクト」での活動です。
        「VTuberの技術・表現・活用の探究」というテーマのもと、既にインターネット上で活動しているバーチャルYouTuberについての研究の他、
        オリジナルバーチャルYouTuber「天ノ葉つむぎ」と「武者丸」を実際に運営しながらメディア表現やキャラクターの活用方法についての研究を行いました。<br>
        来年度も「卒業演習3」「卒業演習4」として活動を継続することが決まっており、来年度はより「VTuber(LIVE配信者)的コミュニケーション」に重点をおいたYouTubeライブ中心の活動や、
        インターネットでアバターを用いて動画投稿活動をしている人全般についての分類・定義などの研究を行う予定です。<br>
        <br>
        「天ノ葉つむぎ」と「武者丸」のコンセプトは「和風」です。<br>
        これについては早い段階でメンバー全員で決定しており、そこから「我々の住む地球とは違う世界に住んでいる」「ある日突然日本に飛ばされてしまう」「TwitterやYouTubeといったSNSを通して人々と交流をする」という
        趣旨を加えました。<br>
        メインのコンテンツである動画シリーズでは、つむぎと武者丸が日本に飛ばされてしまうストーリーや元の世界に戻るために奮闘している様子が描かれています。
        動画シリーズでの展開に合わせてつむぎと武者丸個人のTwitterアカウントが開設されたり、10月に行ったつむぎと武者丸によるLIVE配信での視聴者のコメントがその後の動画シリーズに反映されたりなどといった展開も合わせて行いました。<br>
        また、「天ノ葉つむぎ」と「武者丸」というキャラクターでの他メディア展開として、オリジナルグッズの制作・販売やLINEスタンプ販売、他媒体(<router-link to="/otofuda">音札</router-link>)とのコラボレーション施策などを実際に行いました。<br>
        <br>
        専修大学ネットワーク情報学部「プロジェクト」の公式サイトは<a href="https://www.ne.senshu-u.ac.jp/project2020/" target="_blank" rel="noopener noreferrer">こちら</a>
      </p>
    </div>
    
    <h3>担当した箇所</h3>
    <div class="content">
      <div class="ribon"><h4>動画内イラスト</h4></div>
      <p>
        動画シリーズ各回では、Live2Dの立ち絵で表現しきれないアニメーションをデフォルメイラストのストップモーションで表現しました。<br>
        そのイラスト制作を担当しました。<br>
        Live2Dで表現しきれない部分の補完であるという性質上、特に動きや表情をしっかりデフォルメしてやや大袈裟めに描くことを特に意識して制作しました。<br>
        また、かき氷を作る回やぬいぐるみの武者丸をつむぎが洗う回、ドラムを叩く回などでは、メインとなるキャラクターの手や足の動きだけでなく、かき氷がだんだん出来上がる様子や洗濯桶の泡などの
        小物の差分もたくさん用意し、アニメーションがより魅力的になるよう工夫しました。
      </p>
      <div class="ribon"><h4>デフォルメ立ち絵</h4></div>
      <p>
        動画内では「前回のあらすじ」コーナーに登場し、グッズ展開でも使われたデフォルメバージョンの立ち絵の制作を担当しました。<br>
        こちらは立ち絵なので、動画シリーズ内のアニメーションのために制作したイラストとはうってかわって動きを少なめにして衣装などの描き込みも多めにいています。<br>
        パーツごとの差分もより細かく分けていて、組み合わせによって様々な表情が表現できるように工夫しています。<br>
        <br>
        今年度はイラストの制作者である私がそれぞれの差分を組み合わせて1枚のイラストにしたものをチーム内で共有して使っていましたが、来年度の活動では
        ブラウザ上で差分を自由に組み合わせて1枚のイラストとして出力できる内部むけツールの開発をする予定となっています。
      </p>
      <div class="ribon"><h4>グッズイラスト・デザイン</h4></div>
      <p>
        グッズ展開のための描き下ろしイラストや、イラストから入稿用デザインを制作する過程を担当しました。<br>
        「むぎむしゃサコッシュ」という商品では、サコッシュのナチュラルなカラーと雰囲気に合わせてゆるめのタッチでつむぎと武者丸の日常のワンシーンを描きました。<br>
        また、「むぎむしゃスマホケース」という商品では、メンバーが描いたつむぎと武者丸のイラストをタイリング処理し、動画内でつむぎが使っていたスマホのケースのカラーである紫と、シンプルな白を背景に合わせた2色展開で
        リリースしました。<br>
      </p>
      <div class="ribon"><h4>LINEスタンプ</h4></div>
      <p>
        つむぎと武者丸の描き下ろしイラスト40個を使用したLINEスタンプの、20個を担当しました。<br>
        LINEスタンプ用のイラストは、他のどのイラストとも違って20個分全てイラストのタッチを揃える必要があり、制作に苦労しました。<br>
        また、どんなイラストを採用するかについてもメンバーと相談を重ね、普段使いしやすいものを選ぶなどの工夫をしました。
      </p>
      <div class="ribon"><h4>ウェブサイト(学内・学外)</h4></div>
      <p>
        藤原プロジェクトでは、学部指定のプロジェクト公式サイトとは別に、動画シリーズの視聴者など一般の方々へ向けた情報発信サイトも制作しています。<br>
        学内向けのプロジェクト公式サイトでは、授業としての活動内容の紹介や議事録まとめブログへのリンクなどの学部から指定を受けた内容を中心に取り扱っています。
        一方で学外向け情報発信サイトでは、より詳しいキャラクター紹介や動画シリーズの紹介など、コンテンツの内容に重点をおいた内容を掲載しています。<br>
        <br>
        どちらのサイトもVue.jsを導入し、私を含む3名のプログラマーで担当しました。<br>
        学内向けサイトではLinksエリアとフッターの実装・Worksエリアのアップデートを担当し、学外向けサイトではAboutエリアと動画埋め込み表示エリアの実装を担当しています。<br>
        また、両サイトにてメンバーのコードレビューも行っています。
      </p>
      <div class="ribon"><h4>その他</h4></div>
      <p>
        上記の他、キャラクターデザインのアイディア出しや広報活動にも参加しています。<br>
        また、<router-link to="/otofuda">音札</router-link>とのコラボレーションの際に、双方を取りまとめる総合プロデューサー的役割を担当しました。
      </p>
    </div>
    
    <h3>工夫した点/苦労した点・その他コメント</h3>
    <div class="content">
      <div class="ribon"><h4>イラストに関して</h4></div>
      <p>
        イラストはどれも限られた期間での制作となり、納期に間に合わせ且つ一定のクオリティを保つことに苦労しました。<br>
        そのような状況下でも、動画の回を追うごとにストップモーションアニメーションパートの表現の幅を少しずつ増やすことができたと考えています。（差分の量や動きの細かさなど）<br>
        特に動画用イラストに関しては、Live2Dの立ち絵を制作したメンバーと絵のタッチが大きく違うため、画面に変化をつけるという点においてもそこそこの役割を果たせたと思います。
      </p>
      <div class="ribon"><h4>ウェブ制作に関して</h4></div>
      <p>
        制作しているコンテンツの性質上、イラストのタスクがメインとなり開発のタスクは他のメンバーに大部分を任せる形となってしまいました。<br>
        最初に制作に取り掛かった学内向けプロジェクト公式サイトでは、Vue.jsフレームワークにほぼ初めて触れた機会でしたが、フレームワークの機能やGitHubを上手く使って
        滞りなくチーム制作を行うことができました。
      </p>
      <div class="ribon"><h4>その他・一年の授業を通して</h4></div>
      <p>
        藤原プロジェクトでの活動は、技術的な向上だけでなくチームで一つの作品を作りあげる経験として大きな価値があったように感じています。<br>
        Slackを上手く使ったり、ミーティングの導入に良かった出来事を報告する雑談タイムを取り入れたりして、チーム全員が気軽に発言できるような空気を作っていたことで、
        円滑に一年通して活動を続けられたのだと思います。<br>
      </p>
    </div>
        
    <h3>関連リンク</h3>
    <div class="content">
      <p>
        藤原プロジェクト2020に関する各種リンクはこちらです。<br>
        <ul>
          <li>
            <a href="http://www.ne.senshu-u.ac.jp/~proj2020-23/" target="_blank" rel="noopener noreferrer">学内向けプロジェクト概要ページ</a>
            <a href="https://github.com/habakigumi/univ-web" target="_blank" rel="noopener noreferrer"><img src="../assets/GitHub-Mark-64px.png" class="git"></a>
          </li>
          <li><a href="https://habakigumi.netlify.app/" target="_blank" rel="noopener noreferrer">学外向け情報発信サイト</a></li>
          <li><a href="https://www.youtube.com/channel/UC6sjImHi5w_9mVVfkXauF3g" target="_blank" rel="noopener noreferrer">YouTubeチャンネル</a></li>
          <li><a href="https://www.ne.senshu-u.ac.jp/~proj2019-13/special" target="_blank" rel="noopener noreferrer">音札コラボ特設サイト</a></li>
        </ul>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mugimusha',
  head: {
    title: {
      inner: '藤原プロジェクト2020',
      complement: 'Megane Case'
    },
    meta: [
      { name: 'robots', content: 'noindex'}
    ]
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/body";

</style>
